import {NgModule} from '@angular/core';
import {SiDashboardComponent} from "./page/overview/si-dashboard/si-dashboard.component";
import {SiIndexRunComponent} from "./component/protected-components/si-index-run/si-index-run.component";
import {SiBrowseComponent} from "./page/overview/si-browse/si-browse.component";
import {SiIndexRunObjectPage} from "./page/object/si-index-run-object-page/si-index-run-object.page";
import {SiConfigPage} from "./page/overview/si-config/si-config.page";
import {SiOverviewPage} from "./page/si-overview-page/si-overview.page";
import {SiStatisticsComponent} from "./page/si-overview-page/components/statisticsComponent/si-statistics.component";
import {SiKpiComponent} from "./page/si-overview-page/components/kpiComponent/si-kpi.component";
import {
    SearchWithFieldComponent
} from "./component/protected-components/search-with-field-component/search-with-field.component";
import {
    SearchStrategyPlaygroundComponent
} from "./component/protected-components/search-strategy-playground/search-strategy-playground.component";
import {SiOverviewComponent} from "./component/protected-components/si-overview/si-overview.component";
import {SiFullIndexingComponent} from "./component/protected-components/si-full-indexing/si-full-indexing.component";
import {SiDeltaIndexingComponent} from "./component/protected-components/si-delta-indexing/si-delta-indexing.component";
import {SI_ENTITY_PROVIDER} from "./si.entity-provider";
import {UiModule} from "../../core/ui/ui.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {CoreModule} from "../../core/core.module";
import {SI_TEST_PROVIDERS} from "./test/si-test-definition";

@NgModule({
    declarations: [
        SiDashboardComponent,
        SiIndexRunComponent,
        SiBrowseComponent,
        SiIndexRunObjectPage,
        SiConfigPage,
        SiOverviewPage,
        SiStatisticsComponent,
        SiKpiComponent,
        SearchWithFieldComponent,
        SearchStrategyPlaygroundComponent,
        SiOverviewComponent,
        SiFullIndexingComponent,
        SiDeltaIndexingComponent,
    ],
    exports: [
        SiDashboardComponent,
        SiIndexRunComponent,
        SiBrowseComponent,
        SiIndexRunObjectPage,
        SiConfigPage,
        SearchWithFieldComponent,
        SearchStrategyPlaygroundComponent
    ],
    imports: [
        CoreModule,
        UiModule
    ],
    providers: [SI_ENTITY_PROVIDER, SI_TEST_PROVIDERS]
})
export class SiModule implements DynamicModule {

    alias = 'si';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return SiKpiComponent;
    }

    getStatisticsComponent() {
        return SiStatisticsComponent;
    }
}